<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/index"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>资金流水</div>
		<div></div>
	</header>
	<div class="z-body">
		<!-- 查询 -->
		<div class="z-form-search" style="border-bottom:1px solid #2C2E33;">
			<div>
				<v-menu 
					ref="menu" 
					:close-on-content-click="false" 
					v-model="menu" 
					:nudge-right="-20" 
					:nudge-top="40" 
					lazy 
					transition="scale-transition" 
					offset-y 
					full-width
				>
					<v-text-field 
						style="margin: 0px;" 
						slot="activator" 
						v-model="dateFormatted" 
						persistent-hint 
						prepend-icon="event">
					</v-text-field>
					<v-date-picker 
						style="background-color: #3D3D3D" 
						v-model="date" 
						no-title 
						@input="menu = false">
					</v-date-picker>
				</v-menu>
			</div>
			<div>
				&nbsp;至&nbsp;
			</div>
			<div>
				<v-menu 
					ref="menu2" 
					:close-on-content-click="false" 
					v-model="menu2" 
					:nudge-right="-20" 
					:nudge-top="40" 
					lazy 
					transition="scale-transition" 
					offset-y 
					full-width
				>
					<v-text-field 
						style="margin: 0px;" 
						slot="activator" 
						v-model="dateFormatted2" 
						persistent-hint 
						prepend-icon="event" >
					</v-text-field>
					<v-date-picker 
						style="background-color: #3D3D3D;" 
						v-model="date2" 
						no-title 
						@input="menu2 = false">
					</v-date-picker>
				</v-menu>
			</div>
			<div>
				<div class="z-form-search-btn" @click="downCallback">查询</div>
			</div>
		</div>
		<!-- 数据 -->
		<div>
			<div class="z-index-balance">
				<div>类型</div>
				<div>金额</div>
				<div>时间</div>
			</div>
			<div ref="mescroll" id="z-balance-mescroll" class="mescroll">
				<div>
					<div v-for="(item,index) in data" class="z-index-balance">
						<div v-text="item.type"></div>
						<div v-text="item.money" :style="{color:item.money<0 ? '#DC6A50' : '#05AD7B'}"></div>
						<div v-text="item.atime"></div>
					</div>
				</div>
			</div>
		</div>

	</div>
</div>
</template>

<script>
export default {
	name: 'publishRecord',
	data() {
		return {
			date: new Date().toISOString().substr(0, 10),
			dateFormatted: new Date().toISOString().substr(0, 10),
			menu: false,
			date2: new Date().toISOString().substr(0, 10),
			dateFormatted2: new Date().toISOString().substr(0, 10),
			menu2: false,
			data:[],
			//上拉下拉
			mescroll: null,
		}
	},
	watch: {
		date (val) {
			this.dateFormatted = this.date
		},
		date2 (val) {
			this.dateFormatted2 = this.date2
		}
	},
	mounted() {
		this.mescrollInit()
	},
	methods: {
		// mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit () {
			let _this = this;
			_this.mescroll = new MeScroll("z-balance-mescroll",{
				up:{
					callback: _this.upCallback
				}
			})
		},
		// 下拉回调 、 查询回调
		downCallback(){
			let _this = this
			_this.getList(1,function (rs) {
			})
		},
		// 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
		upCallback (page, mescroll) {
			let _this = this
			_this.getList(page.num,function (rs) {

			})
		},
		getList(pageIndex,callback){
			let _this = this
			// 联网请求
			this.get('api/UserAccount/waterList', {
				stime:this.date,
				etime:this.date2,
				page: pageIndex, // 页码
				limit: 15 // 每页长度
			}).then((rs) => {
				let arr = rs.data.data
				// 如果是第一页需手动置空列表
				if (pageIndex === 1) {
					_this.data = []
				}

				if (arr.length == 0) 
				{
					_this.$store.commit('layer','暂无数据')
				}
				else {
					// 把请求到的数据添加到列表
					_this.data = _this.data.concat(arr)
				}
				callback && callback(rs)
				// 数据渲染成功后,隐藏下拉刷新的状态
				_this.$nextTick(() => {
					_this.mescroll.endSuccess(arr.length)
				})
				
			}).catch((e) => {
				// 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
				_this.mescroll.endErr()
			})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.z-index-balance{
	display: -webkit-flex; /* Safari */
	display: flex;
	justify-content:flex-start;
	padding: 10px;
	border-bottom: 1px solid #2B2D32;
	font-size: 14px;
	color: #6C6C6C;
}
.z-index-balance>div:nth-child(1) {
	width: 20%;
}
.z-index-balance>div:nth-child(2) {
	width: 20%;
}
.z-index-balance>div:nth-child(3) {
	width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/balance.vue